import React from 'react';
import { LinkInterface } from 'atomic/utilization/link/link.interface';
import getButtonClasses from 'atomic/utilization/button/button.helper';
import getLinkClasses from './link.helper';
import './link.scss';

const Link: React.FC<LinkInterface> = ({
    href,
    title,
    rel,
    target,
    className,
    size = 'md',
    color,
    outline = false,
    block = false,
    uppercase = false,
    weight = '500',
    type = 'link',
    noWrap,
    onClick,
    children,
    ariaLabel,
    styles = {}
}) => {
    const classes = type === 'button'
        ? getButtonClasses({ color, block, uppercase, outline, size, weight, noWrap })
        : getLinkClasses({ block, uppercase, size, weight });

    return (
        <a
            href={href}
            onClick={onClick}
            rel={rel}
            target={target}
            className={`${classes} ${className || ''}`}
            title={title}
            aria-label={ariaLabel}
            style={styles}
        >
            {children}
        </a>
    );
};

export default Link;
